<template>
  <div class="row">
    <loader v-if="loading"></loader>
    <div v-else>
      <h1>Adicionar Campo</h1>
      <hr>
      <div>
        <div class="form-group">
          <label for="name">Nome</label>
          <input id="name" class="form-control" v-model="newField.name" placeholder="Nome">
        </div>
        <div class="form-group">
          <label for="description">Descrição</label>
          <textarea id="description" type="text" class="form-control" v-model="newField.description"
                        placeholder="Descrição"></textarea>
        </div>
        <div class="form-group">
          <label for="type">Tipo</label>
          <select id="type" class="form-control" v-model="newField.type" placeholder="Tipo" v-on:change="change()">
              <option v-for="fieldType in fieldTypes" v-bind:value="fieldType">{{fieldType}}</option>
          </select>
        </div>
        <div class="form-group row" v-if="show">
              <div class="col-md-6">
                <label for="select-items">Opções do select</label>
                <div class="text-muted">Adicione os items como linhas, com duas colunas separadas por ";" (ponto e vírgula). <b>Ex: 12345; Item de Exemplo</b></div>
                <textarea id="select-items" v-model="optionsCSV" class="form-control" rows="6" placeholder="Opções"></textarea>
              </div>
              <div class="col-md-6">
                <label>Resultado</label>
                <div class="text-muted">Verifique se os itens foram reconhecidos corretamente.</div>
                <table class="table table-bordered table-sprited">
                  <thead>
                    <tr>
                      <th>Identificador</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in newField.options">
                      <td>{{item.code}}</td>
                      <td>{{item.name}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>
        <div class="form-group">
            <label for="required">Obrigatório</label>
            <input id="required" type="checkbox" v-model="newField.required" />
        </div>
        <div class="form-group">
            <label for="required">Campo Privado</label>
            <input id="required" type="checkbox" v-model="newField.private" />
        </div>
        <button id="btn-save-field" type="button" class="btn btn-primary" @click="save">Salvar</button>
        <button type="button" class="btn btn-default" @click="cancel">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Parse,
  miniToastr
} from '../Global'

import Loader from './util/Loader'
import Multiselect from 'vue-multiselect'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader,
    Multiselect
  },
  data () {
    return {
      loading: false,
      show: false,
      stepParse: null,
      newField: { required: false, options: [] },
      optionsCSV: '',
      fieldTypes: ['text', 'date', 'number', 'file', 'select', 'link', 'textarea', 'user']
    }
  },
  mounted () {
    let id = this.$route.params.id
    let stepId = this.$route.params.stepId
    this.getInformation(id, stepId)
  },
  watch: {
    optionsCSV (newValue) {
      let list = []
      let lines = newValue.split('\n')
      lines.forEach(line => {
        if (line) {
          let columns = line.split(';')
          list.push({code: columns[0], name: columns[1]})
        }
      })
      this.newField.options = list
    }
  },
  methods: {
    getInformation (id, stepId) {
      let self = this
      self.loading = true
      let query = new Parse.Query('Step')
      query.get(stepId).then(result => {
        self.stepParse = result
        let queryFields = new Parse.Query('StepField')
        return id ? queryFields.get(id) : Parse.Promise.as(false)
      }).then(result => {
        if (result) {
          self.newField = result.toJSON()
          let options = result.get('options')
          let builder = []
          options.forEach((opt, i) => {
            if (i > 0) builder.push('\n')
            builder.push(opt.code)
            builder.push(';')
            builder.push(opt.name)
          })
          self.optionsCSV = builder.join('')
          self.show = options.length > 0
        } else {
          self.newField.private = true
        }
        self.loading = false
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    change () {
      this.show = this.newField.type === 'select'
    },
    cancel () {
      this.$router.go(-1)
    },
    save () {
      let self = this
      let StepField = Parse.Object.extend('StepField')
      let StepAction = Parse.Object.extend('StepAction')
      self.loading = true
      let query = new Parse.Query(StepField)
      query.equalTo('step', self.stepParse)
      if (self.$route.params.actionId) {
        let action = new StepAction()
        action.id = self.$route.params.actionId
        query.equalTo('stepAction', action)
      }
      query.count().then(count => {
        let field = new StepField()
        field.set('step', self.stepParse)
        if (self.$route.params.actionId) {
          let action = new StepAction()
          action.set('id', self.$route.params.actionId)
          field.set('stepAction', action)
        }
        if (self.$route.params.id) {
          field.set('id', self.newField.objectId)
        } else {
          field.set('order', count)
        }
        let props = ['name', 'description', 'type', 'required', 'private', 'options']
        props.forEach(attr => {
          field.set(attr, self.newField[attr])
        })
        return field.save()
      }).then(result => {
        self.loading = false
        miniToastr.success('Salvo com sucesso')
        self.$router.go(-1)
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// StepFieldDetail.vue?c36d798a